// extracted by mini-css-extract-plugin
export default {"container":"hybrid-card_container__8YbRJ","thumbnail":"hybrid-card_thumbnail__S1pwg","label":"hybrid-card_label__3cjD8"};